import { Card } from "@/components/ui/card";
import { FileText, Inbox, DollarSign, Percent } from "lucide-react";

interface QuoteMetricsRowProps {
  totalRequests: number;
  openRequests: number;
  avgLowQuote: number | null;
  conversionRate: number | null; // 0..1 or null
  hasAnyData: boolean;
}

/**
 * 4-card KPI row for the shipper "My Quotes" page.
 * Real values only — never fabricated. "Avg Savings" removed per Tim.
 * Deltas are intentionally NOT rendered here (no prior-period data wired yet).
 * // TODO: wire prior-period comparisons before adding delta lines.
 */
export function QuoteMetricsRow({
  totalRequests,
  openRequests,
  avgLowQuote,
  conversionRate,
  hasAnyData,
}: QuoteMetricsRowProps) {
  const cards = [
    {
      label: "Total Requests",
      value: totalRequests.toLocaleString(),
      icon: FileText,
      show: true,
    },
    {
      label: "Open Requests",
      value: openRequests.toLocaleString(),
      icon: Inbox,
      show: true,
    },
    {
      label: "Avg Low Quote",
      value: avgLowQuote != null ? `$${Math.round(avgLowQuote).toLocaleString()}` : "—",
      icon: DollarSign,
      show: true,
    },
    {
      label: "Conversion Rate",
      value:
        conversionRate != null && hasAnyData
          ? `${Math.round(conversionRate * 100)}%`
          : "—",
      icon: Percent,
      show: true,
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {cards.map((c) => {
        const Icon = c.icon;
        return (
          <Card key={c.label} className="p-4">
            <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
              <Icon className="h-3.5 w-3.5 text-brand-teal" />
              {c.label}
            </div>
            <div className="mt-2 text-2xl md:text-[26px] font-bold text-foreground leading-tight">
              {c.value}
            </div>
          </Card>
        );
      })}
    </div>
  );
}

export default QuoteMetricsRow;
